import { Grid, Stack, TextField } from '@mui/material';
import * as React from 'react';
import LocalizationProviderWithLanguages from '../../../../Shared/Localization/LocalizationProviderWithLanguages';
import { DatePicker, PickersDay } from '@mui/x-date-pickers';
import { format, isSameDay, isSameWeek } from 'date-fns';
import { BuildingVovClient, ChangeBuildingImageCreationDateRequest, ImageDiaryDTO } from '../../../../../ApiOld/Api/ApiServerVov';
import { WindowScroller } from 'react-virtualized';
import { useApi } from '../../../../../ApiOld/Api/useApi';
import { useTranslation } from "react-i18next";

export interface IPhotosDateCategorizerProps {
    images: ImageDiaryDTO[];
    onImageDateChanged: (imageId: string, newDate: Date, originUrl: string) => void;
    buildingId: number;
    imageClicked: (image: ImageDiaryDTO) => void;
}

export default function PhotosDateCategorizer(props: IPhotosDateCategorizerProps) {
    const { authorizedApi } = useApi(BuildingVovClient);
    const { t } = useTranslation();
    function onImageDrop(imageId: string, imageData: any, originUrl: string) {
        if (date) {
            authorizedApi.changeBuildingImageDate(new ChangeBuildingImageCreationDateRequest({
                buildingId: props.buildingId,
                imageId: Number(imageId!),
                newDate: date!,
                url: originUrl


            })).then((res) => {

            });
            props.onImageDateChanged(imageId, date, originUrl);
        }
        console.log('Image dropped', imageId, imageData);
    }
    const handleJumpToCurrentWeek = (currenDate) => {
        console.log(`current date: ${currenDate}`);
    }

    const handleWeekPick = (startDate, endDate) => {
        console.log(`${startDate} to ${endDate}`);
    }
    const [date, setDate] = React.useState<Date | null>(new Date());
    const renderImageTile = React.useCallback(
        (image: ImageDiaryDTO, index: number) => {
            return (
                <Grid
                    item
                    key={'key' + image.id}
                    xs={12}
                    sm={12}
                    md={6}
                    lg={4}
                    xl={2}
                    style={{ display: 'flex', justifyContent: 'center' }}
                >

                    <img onClick={() => { props.imageClicked(image); console.log(image) }} src={image.thumbnailUrl} alt={image.name} style={{ width: '100%', height: '100%' }} />
                </Grid>)
        }, [])
    return (
        <Stack>
            <LocalizationProviderWithLanguages>

                {/* <WeekPicker /> */}
                <DatePicker

                    value={date || null}
                    onChange={(newValue) => { if (newValue) setDate(new Date(newValue)); else setDate(null); }}
                    renderInput={(params) => (
                        <TextField {...params} label={t('Date')} size="small" fullWidth />
                    )}
                />
            </LocalizationProviderWithLanguages>
            <div
                onClick={() => {
                    console.log(date?.getDate())
                }}
                onDragOver={(e) => {
                    e.preventDefault(); // Necessary to allow dropping
                    e.currentTarget.style.background = 'rgba(0, 0, 0, 0.1)'; // Visual feedback
                }}
                onDragLeave={(e) => {
                    e.currentTarget.style.background = ''; // Reset background
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    e.currentTarget.style.background = ''; // Reset background

                    const imageId = e.dataTransfer.getData('imageId');
                    const imageUrl = e.dataTransfer.getData('imageUrl');
                    const imageData = JSON.parse(e.dataTransfer.getData('imageData'));

                    // Call your callback function here
                    onImageDrop(imageId, imageData, imageUrl);
                }}
                style={{
                    minHeight: '400px', // Give some height to empty drop zones
                    border: '2px dashed #ccc',
                    borderRadius: '4px',
                    padding: '16px',
                    minWidth: '100px',
                    maxHeight: '500px',
                    overflow: 'auto',
                    display: 'flex',
                    flexWrap: 'wrap',
                    marginTop: '8px'
                }}>
                <WindowScroller>
                    {({ height, isScrolling, onChildScroll, scrollTop, registerChild, width }) => (
                        //@ts-ignore
                        <div ref={registerChild}>
                            <Grid container spacing={2} style={{ padding: '16px' }}>
                                {props.images.filter(x => x.created && isSameDay(new Date(x.created), date!)).map(renderImageTile)}
                            </Grid>
                        </div>
                    )}
                </WindowScroller>

            </div>
        </Stack>
    );
}

